'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    height: 100%;\n    background: white;\n    display: flex;\n    overflow: hidden;\n    min-width: 100%;\n    z-index: 9;\n    opacity: ', ';\n    visibility: ', ';\n    transition: all 0.125s ease-in-out, height 1ms, bottom 1ms;\n'], ['\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    height: 100%;\n    background: white;\n    display: flex;\n    overflow: hidden;\n    min-width: 100%;\n    z-index: 9;\n    opacity: ', ';\n    visibility: ', ';\n    transition: all 0.125s ease-in-out, height 1ms, bottom 1ms;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    opacity: ', ';\n    height: ', ';\n    margin-top: -25px;\n    transition: all 0.25s ease-in-out;\n'], ['\n    opacity: ', ';\n    height: ', ';\n    margin-top: -25px;\n    transition: all 0.25s ease-in-out;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    opacity: ', ';\n    transition: opacity 0.5s ease-in-out;\n    text-align: center;\n    padding: 0 1rem;\n'], ['\n    opacity: ', ';\n    transition: opacity 0.5s ease-in-out;\n    text-align: center;\n    padding: 0 1rem;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _sizes = require('../../constants/sizes');

var _alignments = require('../../constants/alignments');

var _dark = require('../icons/logo/dark');

var _dark2 = _interopRequireDefault(_dark);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _spinner = require('../icons/spinner');

var _spinner2 = _interopRequireDefault(_spinner);

var _label = require('../text/label');

var _label2 = _interopRequireDefault(_label);

var _getScreenSize = require('../../helpers/getScreenSize');

var _getScreenSize2 = _interopRequireDefault(_getScreenSize);

var _isMobile = require('../../helpers/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FullScreen = _styledComponents2.default.div(_templateObject, function (_ref) {
    var visible = _ref.visible;
    return visible ? 1 : 0;
}, function (_ref2) {
    var visible = _ref2.visible;
    return visible ? 'visible' : 'hidden';
});

var SpinnerContainer = (0, _styledComponents2.default)(_container2.default)(_templateObject2, function (_ref3) {
    var visible = _ref3.visible;
    return visible ? 1 : 0;
}, function (_ref4) {
    var visible = _ref4.visible;
    return visible ? '50px' : '0px';
});

var DelayedText = _styledComponents2.default.div(_templateObject3, function (_ref5) {
    var visible = _ref5.visible;
    return visible ? 1 : 0;
});

var Loading = function Loading(_ref6) {
    var _ref6$visible = _ref6.visible,
        visible = _ref6$visible === undefined ? false : _ref6$visible,
        _ref6$inline = _ref6.inline,
        inline = _ref6$inline === undefined ? false : _ref6$inline,
        _ref6$banner = _ref6.banner,
        banner = _ref6$banner === undefined ? false : _ref6$banner,
        logoWidth = _ref6.logoWidth,
        logoHeight = _ref6.logoHeight,
        pageLoadingDisplayText = _ref6.pageLoadingDisplayText,
        _ref6$pageLoadingDisp = _ref6.pageLoadingDisplayTextThresholdInSeconds,
        pageLoadingDisplayTextThresholdInSeconds = _ref6$pageLoadingDisp === undefined ? 3 : _ref6$pageLoadingDisp;

    var _useState = (0, _react.useState)(visible),
        _useState2 = _slicedToArray(_useState, 2),
        isVisible = _useState2[0],
        setIsVisible = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        showSpinner = _useState4[0],
        setShowSpinner = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        _useState6 = _slicedToArray(_useState5, 2),
        showDelayedText = _useState6[0],
        setShowDelayedText = _useState6[1]; // Controls when to show the text

    var spinnerTimerRef = (0, _react.useRef)(null);
    var textTimerRef = (0, _react.useRef)(null);
    var mobile = (0, _isMobile2.default)((0, _getScreenSize2.default)());

    var clearTimers = function clearTimers() {
        if (spinnerTimerRef.current) {
            clearTimeout(spinnerTimerRef.current);
            spinnerTimerRef.current = null;
        }
        if (textTimerRef.current) {
            clearTimeout(textTimerRef.current);
            textTimerRef.current = null;
        }
    };

    (0, _react.useEffect)(function () {
        if (visible) {
            setIsVisible(true);
            setShowDelayedText(false); // Reset delayed text state

            clearTimers();

            spinnerTimerRef.current = setTimeout(function () {
                setShowSpinner(true);

                // Only start text timer if text is provided
                if (pageLoadingDisplayText) {
                    var delayMs = pageLoadingDisplayTextThresholdInSeconds * 1000;
                    textTimerRef.current = setTimeout(function () {
                        setShowDelayedText(true); // Show the text after delay
                    }, delayMs);
                }
            }, 1500);
        } else {
            clearTimers();
            setIsVisible(false);
            setShowSpinner(false);
            setShowDelayedText(false);
        }

        return function () {
            clearTimers();
        };
    }, [visible, pageLoadingDisplayText, pageLoadingDisplayTextThresholdInSeconds]);

    var top = 60;
    if (!mobile) {
        top += 20;
    }
    if (banner) {
        top += 40;
        if (mobile) {
            top += 20;
        }
    }

    var bottom = 60;
    if (mobile) {
        bottom += 20;
    }

    var windowObj = typeof window !== 'undefined' ? window : null;
    if (windowObj) {
        var clientHeight = windowObj.document.documentElement.clientHeight;
        var viewHeight = windowObj.innerHeight;
        var overflow = clientHeight - viewHeight;
        if (overflow > 0) {
            bottom = 0;
        }
    }

    if (!isVisible || !showSpinner) {
        return null;
    }

    var showText = showDelayedText && pageLoadingDisplayText;

    return _react2.default.createElement(
        FullScreen,
        {
            inline: inline,
            banner: banner,
            visible: isVisible,
            top: inline && top,
            bottom: bottom
        },
        _react2.default.createElement(
            _container2.default,
            {
                fullSize: true,
                horizontalAlignment: _alignments.Alignments.center,
                verticalAlignment: _alignments.Alignments.center
            },
            _react2.default.createElement(
                SpinnerContainer,
                { visible: showSpinner, bottom: _sizes.Sizes.sm },
                _react2.default.createElement(_spinner2.default, { size: _sizes.Sizes.xl })
            ),
            _react2.default.createElement(_dark2.default, { width: logoWidth, height: logoHeight }),
            showText && _react2.default.createElement(
                DelayedText,
                { visible: showText },
                _react2.default.createElement(_label2.default, {
                    text: pageLoadingDisplayText,
                    size: _sizes.Sizes.xs,
                    top: _sizes.Sizes.sm
                })
            )
        )
    );
};

Loading.propTypes = {
    visible: _propTypes2.default.bool,
    inline: _propTypes2.default.bool,
    banner: _propTypes2.default.bool,
    logoWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    logoHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    pageLoadingDisplayText: _propTypes2.default.string,
    pageLoadingDisplayTextThresholdInSeconds: _propTypes2.default.number
};

exports.default = Loading;